import { loyalityPointsProgressBar } from '@js/components/loyality-points-progress-bar/loyalityPointsProgressBar';

import { createScriptLoader } from '@bigcommerce/script-loader';

const scriptLoader = createScriptLoader();

const TEMP_MAP_API_KEY = 'AIzaSyCnbAQqAdteu3ZbZ6gbvIERc2QqePSAF38';

window.addEventListener('LivewireComponent.morph.updated.account.tabs.loyalty-program', (e) => {
    const mobileProgressBarContainer = document.querySelector('.vertical-progress-container');
    const stepElements = [
        ...mobileProgressBarContainer.querySelectorAll('[data-active-above-value]'),
    ];

    const stepsData = stepElements.map((element) => ({
        value: parseInt(element.getAttribute('data-active-above-value'), 10),
    }));

    const data = {
        points: 6500,
        steps: stepsData,
    };
    console.log(data.steps);
    loyalityPointsProgressBar(data);
});

let mapInitialized = false;

window.initMap = () => {
    const mapContainerElement = document.querySelector('#showroom-map');

    if (!mapContainerElement) {
        return;
    }

    const mapData = JSON.parse(mapContainerElement.dataset.mapData || '{}');
    const markerData = JSON.parse(mapContainerElement.dataset.markerData || '{}');

    const options = {
        zoom: 12,
        center: mapData,
    };

    const map = new window.google.maps.Map(mapContainerElement, options);

    const marker = new window.google.maps.Marker({
        position: mapData,
        map: map,
        icon: '/img/map-marker.webp',
        ...markerData,
    });
};

window.addEventListener(
    'LivewireComponent.morph.updated.account.tabs.account-overview',
    async (e) => {
        if (mapInitialized) {
            window.initMap();
            return;
        }

        scriptLoader.loadScript(
            `https://maps.googleapis.com/maps/api/js?key=${TEMP_MAP_API_KEY}&callback=initMap`
        );
        mapInitialized = true;
    }
);

// window.addEventListener('LivewireComponent.morph.updated.account.tabs.loyalty-program', (e) => {
//     const { el, component } = e.detail;

//     console.log({ el, component });

//     const progressBar = el.querySelector('.loyalty-progress-bar');

//     console.log({ progressBar });

//     // debugger;
// });

// document.addEventListener('livewire:init', () => {
//     const progressBar2 = document.querySelector('.vertical-progress-bar');
//     console.log(progressBar2);
//     // Runs after Livewire is loaded but before it's initialized
//     // on the page...
// });

// document.addEventListener('livewire:initialized', () => {
//     const progressBar2 = document.querySelector('.vertical-progress-bar');
//     console.log(progressBar2);
//     // Runs immediately after Livewire has finished initializing
//     // on the page...
// });

// const currentPoints = 15000;
// const progressPercentage = loyalityPointsProgressBar(currentPoints);

// document.addEventListener('DOMContentLoaded', () => {
//     const progressBar = document.querySelector('.loyalty-progress-container');
//     console.log(progressBar);
// });

// const progressBar2 = document.querySelector('#progressBar');
// const progressBar3 = document.getElementById('#progressBar');

// console.log(progressBar2);
// console.log(progressBar3);
